import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../shared/components/ScreenLoading'

function SlidersNotifications() {
  const { loading, error, msg } = useSelector((state: IRootState) => state.slider)

  return (
    <>
      <CustomSnackBar errors={[error]} msgs={[msg]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default SlidersNotifications
